import React, {useContext, useEffect, useState} from "react";
import ConfTopicView from "./ConfTopicView";
import {downloadTemplateTopics, getStrutturaTopicsApi} from "./services/TopicServices";
import {TranslateContext} from "../../context/TranslateContext";
import {RuoliContext} from "../../context/RuoliContext";
import {STANDARD_ESRS} from "../../utility/common";
import {ParametersContext} from "../../context/ParametersContext";
import {useHistory} from "react-router-dom";

export default function ConfTopicController() {

    const [loadingData, setLoadingData] = useState(true);

    const [strutturaTopics, setStrutturaTopics] = useState([]);
    const [topicSel, setTopicSel] = useState();
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [showModalUploadTopics, setShowModalUploadTopics] = useState(false);
    const [showEsrs, setShowEsrs] = useState(false);

    const {translate} = useContext(TranslateContext);
    const {getParameterValue} = useContext(ParametersContext);
    const {isRuoloAdmin} = useContext(RuoliContext);

    const token = localStorage.getItem('ns-access-token');

    async function getEsrs() {
        let standards = await getParameterValue('StandardGestiti');
        if (standards) {
            setShowEsrs(standards.includes(STANDARD_ESRS));
        }
    }

    async function getStrutturaTopics() {
        const response = await getStrutturaTopicsApi();
        setStrutturaTopics(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        getEsrs();
        getStrutturaTopics();
    }, []);

    const downloadTemplate = async () => {
        const response = await downloadTemplateTopics();
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            var a = document.createElement("a");
            a.href = "data:application/vnd.ms-excel;base64," + response.data.data;
            a.download = 'template-import-topics.xlsx';
            a.click(); //Downloaded file
        }
    }

    const bottoniDx = [
        isRuoloAdmin() && showEsrs && {
            label: 'Download template',
            icon: 'fas fa-file-excel',
            command: downloadTemplate
        },
        isRuoloAdmin() && showEsrs && {
            label: 'Upload topic',
            icon: 'fas fa-file-upload',
            command: () => {
                setShowModalUploadTopics(true)
            }
        },
    ];

    return (
        <ConfTopicView
            modalMsg={modalMsg}
            setShow={setShow}
            loadingData={loadingData}
            treeData={strutturaTopics}
            bottoniDx={bottoniDx}
            show={show}
            topicSel={topicSel}
            showModalUploadTopics={showModalUploadTopics}
            setShowModalUploadTopics={setShowModalUploadTopics}
            updateDati={getStrutturaTopics}
            token={token}
            translate={translate}
        />
    );
}
